import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import uuidv4 from 'uuid';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import { navigate, openDialog } from '../../actions';

import { updateZonaDB } from '../../actions/zona_actions';

const styles = theme => ({
    buttonsBottom: {
        margin: '20px 15px 30px 8px',
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});


class ZonaActionButtons extends Component {

    messageDialog = msg => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };

    checkRequiredFields = zona => {
        if (!zona.descr) {
            this.messageDialog('Por favor, rellene el campo Descripción');
            return false;
        } else if (isNaN(zona.iTipoZona)) {
            this.messageDialog('Por favor, rellene el campo Tipo de zona');
            return false;
        } else if (isNaN(zona.iCajaDestino)) {
            this.messageDialog('Por favor, rellene el campo Caja de destino');
            return false;
        }

        else return true;

    };


    updateHandler = () => {

        this.props.zonaDetallesTipoPartida.tiposPartida.forEach(p => {
            if (typeof p.id !== 'number') p.id = -1;
        });

        this.props.zonaProductos.zonaProductos.forEach(p => {
            if (typeof p.id !== 'number') p.id = -1;
        });

        this.props.zonaProductosCaja.productosCaja.forEach(p => {
            if (typeof p.id !== 'number') p.id = -1;
        });

        const zona = {
            id: this.props.zonaDetalles.zona.id,
            centroId: this.props.zonaDetalles.zona.centroId,
            iTipoZona: this.props.zonaDetalles.zona.iTipoZona,
            descr: this.props.zonaDetalles.zona.descr,
            activo: this.props.zonaDetalles.zona.activo,
            tipoZona: this.props.zonaDetalles.zona.tipoZona,
            iCajaDestino: this.props.zonaDetalles.zona.iCajaDestino,
            elemCajaId: this.props.zonaDetalles.zona.elemCajaId,
            elemNoCajaId: this.props.zonaDetalles.zona.elemNoCajaId,

            productos: this.props.zonaProductos.zonaProductos,
            productosCaja: this.props.zonaProductosCaja.productosCaja,
            tipoPartidas: this.props.zonaDetallesTipoPartida.tiposPartida,
            maquinas: this.props.zonaMaquinas.zonaMaquinas
        };

        if (this.checkRequiredFields(zona)) {
            this.props.updateZonaDB(zona, this.props.match.params.id);
        };

    };

    render() {

        const { classes } = this.props;

        return (
            <div>
                <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={this.props.backHandler}>Atrás</Button>
                
                <Button
                    disabled={this.props.zonaProductosCaja.isLoading || this.props.zonaProductos.isLoading || this.props.zonaDetallesTipoPartida.isLoading || this.props.zonaDetalles.isLoading}
                    className={classes.buttonsBottom}
                    variant="contained"
                    color="primary"
                    onClick={() => this.updateHandler()}>
                    Guardar
                </Button>
            </div>
        );
    };

};

ZonaActionButtons.propTypes = {
    //state
    zonaDetalles: PropTypes.object.isRequired,
    zonaDetallesTipoPartida: PropTypes.array.isRequired,
    zonaProductos: PropTypes.array.isRequired,
    zonaProductosCaja: PropTypes.array.isRequired,
    zonaMaquinas: PropTypes.array.isRequired,
    //dispatch
    updateZonaDB: PropTypes.func.isRequired,
    navigate: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        zonaDetalles: state.zonaDetalles,
        zonaDetallesTipoPartida: state.zonaDetallesTipoPartida,
        zonaProductos: state.zonaProductos,
        zonaProductosCaja: state.zonaProductosCaja,
        zonaMaquinas: state.zonaMaquinas,
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateZonaDB: updateZonaDB,
        navigate,
        openDialog,
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withStyles(styles, { withTheme: true })(ZonaActionButtons)));